import clsx from "clsx";
import * as React from "react";
import HamburgerMenu from "../common/HamburgerMenu";
import Button from "./Button";

type NavLayoutHeaderProps = {
  logo: React.ReactNode;
  isOpen: boolean;
  onToggleMenu?: () => void;
};

const NavLayoutHeader: React.FC<NavLayoutHeaderProps> = ({
  logo,
  isOpen,
  onToggleMenu,
}) => {
  return (
    <header
      data-testid="nayLayout_header"
      className={clsx(
        "bg-white",
        "dark:bg-gray-800",
        "grid",
        "grid-cols-2",
        "px-4",
        "py-2",
        "md:py-[0.875rem]",
        "fixed",
        "top-0",
        "left-0",
        "right-0",
        "z-20",
        "min-h-16"
      )}
    >
      <div className={clsx("flex", "justify-start", "items-center")}>
        {logo}
      </div>
      <div className={clsx("flex", "justify-end", "items-center", "gap-4")}>
        <Button
          compact
          type="none"
          onClick={onToggleMenu}
          className={clsx("leading-none")}
        >
          <HamburgerMenu isOpen={isOpen} />
        </Button>
      </div>
    </header>
  );
};

export default NavLayoutHeader;
